import React, { useEffect, useState } from "react";
import TextAreaField from "../../forms/textarea-field";
import InputField from "../../forms/input-field";
import { useDispatch } from "react-redux";
import SelectField from "../../forms/select-field";
import { stateListAction } from "../../../redux/actions/general-action";
import { useFormikContext } from "formik";
import { pincodeListAction } from "../../../redux/actions/general-action";

const StoreDrugAddressTab = () => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();

  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    dispatch(stateListAction(onSuccessState, onErrorState));
  }, []);

  const onSuccessState = (data) => {
    setStateList(
      data.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onErrorState = () => {};

  function fetchCountryFromPincode(pincode) {
    if (pincode?.length === 6) {
      dispatch(
        pincodeListAction(
          pincode,
          (response) => {
            if (response?.[0]?.Status !== "Error") {
              const postOffice = response?.[0]?.PostOffice?.[0];
              const country = postOffice?.Country ?? "";
              setFieldValue("dl_country_region", country.toLowerCase() === "india" ? "india" : country || "india");
              setFieldValue("dl_region", postOffice?.District ?? "");
            }
          },
          () => {}
        )
      );
    } else {
      setFieldValue("dl_country_region", "");
      setFieldValue("dl_region", "");
    }
  }

  useEffect(() => {
    if (values.dl_pin_code?.length === 6) {
      fetchCountryFromPincode(values.dl_pin_code);
    }
  }, [values.dl_pin_code]);
  return (
    <div className="w-full 2xl:w-[30%] lg:w-[60%] px-5 xl:px-10">
      <TextAreaField
        label="Address "
        placeholder="Enter Address"
        name="dl_address"
        id={"dl_address"}
        // isRequired={true}
        labelWidth="8.5rem"
        feildHeight="5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_area"
        placeholder="Enter Area"
        label="Area"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_landmark"
        placeholder="Enter Landmark"
        label="Landmark"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_town_or_village"
        placeholder="Enter Town/ Village"
        label="Town/ Village"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_city"
        placeholder="Enter City"
        label="City"
        labelWidth="8.5rem"
      />
      <SelectField
        placeholder={"Select state"}
        options={stateList}
        label={"Select State"}
        id={"dl_state"}
        name="dl_state"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        // isRequired={true}
        labelWidth="8.5rem"
      />

      {/* Auto-filled from pincode lookup — see fetchCountryFromPincode above. */}
      <SelectField
        isDisabled={true}
        // isRequired={true}
        placeholder={"Select country"}
        options={countryList}
        label={"Country"}
        id={"dl_country_region"}
        name="dl_country_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <InputField
        // isRequired={true}
        type="text"
        name="dl_pin_code"
        placeholder="Enter Pincodde"
        label="Pin Code"
        labelWidth="8.5rem"
        handleChange={(e) => fetchCountryFromPincode(e?.target?.value)}
      />
    </div>
  );
};

export default StoreDrugAddressTab;

const countryList = [{ label: "India", value: "india" }];
